export function hasSkill(character, skillIdOrName) {
	if (!skillIdOrName) {
		return true;
	}

	return !!character?.skills?.find(skill => (skill?._id === skillIdOrName || skill?.name?.toLowerCase() === skillIdOrName?.toLowerCase()));
}

export const UNSKILLED_COST_MULTIPLIER = 10;